// extracted by mini-css-extract-plugin
export var loadingSpinner = "_58-1";
export var standaloneTable = "_58-0";